export default __webpack_public_path__ + "60d514632c9d33d8f24edc17c0507d1c.png";